export class RecoverPasswordData {

  public confirmation: string;
  public password: string;
  public token: string;

  constructor(password: string, token: string) {
    this.confirmation = password;
    this.password = password;
    this.token = token;
  }

}
